import React, { useState, useEffect } from "react";
import { collection, getDocs, getFirestore, deleteDoc, doc } from "firebase/firestore";
import { app } from '../../credenciales';
import { Button, Table, Container, Spinner, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import style from "./ListaProfesores.module.css";
import ActivityFormModal from "../../components/Modals/ActivityFormModal";
import { FaTrash, FaPen, FaPlus, FaEye } from "react-icons/fa6";
import Swal from 'sweetalert2';

const ListaProfesores = () => {
  const [profesores, setProfesores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [profesorIdToEdit, setProfesorIdToEdit] = useState();

  const db = getFirestore(app);

  const getProfesores = async () => {
    const profesoresCollection = collection(db, "usuarios");
  
    try {
      const responseDb = await getDocs(profesoresCollection);
      const profesoresList = responseDb.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((user) => user.role === "3"); // Filtrar solo profesores
      setProfesores(profesoresList);
    } catch (error) {
      console.error("Error al obtener los profesores:", error);
    } finally {
      setLoading(false);
    }
  };  

  useEffect(() => {
    getProfesores();
    //console.log(actividades);
  }, []);

  const handleDeleteActivity = async (profesorId) => {
    try {
      Swal.fire({
        title: "¿Desea borrar a este profesor?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "Cancelar"
      }).then(async (result) => {
        if (result.isConfirmed) {
          await deleteDoc(doc(db, "usuarios", profesorId));
          Swal.fire({
            title: "¡Profesor eliminado!",
            icon: "success"
          });
          getProfesores();
        }
      });
    } catch (error) {
      console.error("Error al eliminar el documento:", error);
    }
  }

  return (
    <Container className="py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="titles">Lista de profesores</h1>
      </div>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      ) : profesores.length > 0 ? (
        <Table striped bordered hover responsive className="shadow-sm overflow-hidden">
          <thead>
            <tr>
              <th>Nombre del profesor</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {profesores.map((profesor) => (
              <tr key={profesor.id}>
                <td>
                  <NavLink to={`/profesorPage/${profesor.id}`} className={style.links}>
                    {profesor.name} {profesor.lastName}
                  </NavLink>
                </td>
                <td>
                  <Row>
                    <Col>
                      <Button variant="primary" size="sm">
                        <NavLink to={`/profesorPage/${profesor.id}`} className={style.links}>
                          <FaEye color="#ffffff" />
                        </NavLink>
                      </Button>

                      {/* <Button variant="warning" size="sm" onClick={() => handleShowEditModal(profesor.id)} className="mx-2">
                        <FaPen color="#ffffff" />
                      </Button>

                      <Button variant="danger" size="sm" onClick={() => { handleDeleteActivity(profesor.id) }}>
                        <FaTrash color="#ffffff" />
                      </Button> */}
                    </Col>
                  </Row>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p className="text-center text-muted">No hay profesores disponibles.</p>
      )}
    </Container>
  );
};

export default ListaProfesores;
